import React, { useState } from 'react';
import Calendar from 'react-calendar';
import moment from 'moment';
import { Tooltip } from 'react-tooltip';
import 'react-calendar/dist/Calendar.css';
import 'react-tooltip/dist/react-tooltip.css';
import {Box} from "@mui/material";

const ShiftCalendar = ({ shifts }) => {

  const [date, setDate] = useState(new Date());

  const getTileContent = ({ date, view }) => {
    if (view === 'month') {
      const dateString = moment(date).format('YYYY-MM-DD');
      const shift = shifts.find(shift =>
        moment(shift.shift_start_date).isSameOrBefore(dateString) &&
        moment(shift.shift_end_date).isSameOrAfter(dateString)
      );
      if (shift) {
        const tooltipId = `tooltip-${dateString}`;
        return (
          <div>
            <div data-tooltip-id={tooltipId} className="tooltip-target">⏱️</div>
            <Tooltip id={tooltipId} place="top" effect="solid">
              <p>Başlangıç:{moment(shift.shift_start_date).format('DD/MM/YYYY')} - {shift.start_hour}</p>
              <p>Bitiş: {moment(shift.shift_end_date).format('DD/MM/YYYY') } - {shift.end_hour}</p>
            </Tooltip>
          </div>
        );
      }
    }
    return null;
  };

  return (
 <>
     <Box style={{padding:10}}>


       <Calendar
        onChange={setDate}
        value={date}
        tileContent={getTileContent}
      />
     </Box>
   </>
  );
};

export default ShiftCalendar;
